import {LocationIcon} from "./LocationIcon";
import {Badge, Flex, HStack, Text} from "@chakra-ui/react";
import {DealGroup, getShortBarName} from "../tools/groupDeals";
import {BarChain} from "../../interfaces/Bar";

export interface LocationBadgeProps {
    name: string;
}

export const LocationBadge = (props: LocationBadgeProps) => (
    <Badge borderRadius="4px" textTransform="none" colorScheme="orange" w="max-content">
        <HStack spacing={1} align="center">
            <LocationIcon/>
            <Text mb={0}>{props.name}</Text>
        </HStack>
    </Badge>
);

export interface LocationListProps {
    dealGroup: DealGroup;
    chain: BarChain;
}

export const DealGroupLocationList = (props: LocationListProps) => (
    <Flex gap={1} wrap={"wrap"}>
        {
            props.dealGroup.bars.map(b => getShortBarName(b, props.chain)).map((barName) => (
                <LocationBadge key={barName} name={barName}/>
            ))
        }
    </Flex>
)